module.exports = __webpack_public_path__ + "img/鸦胆子.a9d5bc5d.jpg";